import React, {FC} from 'react';
import {classNames} from '@modules/casting/String';
import {ParagraphType} from './TextTypes';


const P: FC<ParagraphType> = ({className, ...props}) => <p {...props}
    className={classNames('text-neutral-800 text-md', className)}
/>;
export default P;